// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3RQm8","alert":"SettungsInbox_alert__1Qang"};